/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".header[_ngcontent-%COMP%]{position:absolute;top:0;left:0;width:100%}.header-menu[_ngcontent-%COMP%]{position:relative;margin:0 -20px}.header-menu__list[_ngcontent-%COMP%]{margin:0;padding:0;list-style:none;float:right;font-size:13px}.header-menu__item[_ngcontent-%COMP%]{float:left}.header-menu__item--main[_ngcontent-%COMP%]{position:absolute;top:0;left:0}.header-menu__link[_ngcontent-%COMP%]{display:block;line-height:20px;padding:20px;color:#fff;text-decoration:underline}.header-menu__link--active[_ngcontent-%COMP%], .header-menu__link[_ngcontent-%COMP%]:hover{text-decoration:none}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/shared/components/header/header.component.styl.shim.ngstyle.js.pre-build-optimizer.js